import * as React from 'react'
import { Button } from '@/ui/button'
import { GenericErrorModel } from 'app/models/genericErrorModel'
import {
  withLocalizeProps,
  type LocalizeProps,
} from '@/modules/shared/context/localize/LocalizeContext'
import { isAdmin, isPaymentAdmin } from 'app/services/local/roleService'

import { homeRoutesMap } from '@/modules/home/routes'
import { corePath } from '@/modules'

import { FullLogo } from '@/app/features/icons/FullLogo'
import { withRouter, RouteComponentProps } from '@/app/navigation/withRouter'

export type GenericErrorPresenterStateProps = {
  error: GenericErrorModel
  companyId: string
}

export type GenericErrorPresenterDispatchProps = {}
export type GenericErrorPresenterOwnProps = {}

type MatchParams = {}

type GenericErrorPresenterProps = GenericErrorPresenterStateProps &
  GenericErrorPresenterDispatchProps &
  GenericErrorPresenterOwnProps
type State = {}

class GenericErrorPresenter extends React.Component<
  GenericErrorPresenterProps &
    LocalizeProps &
    RouteComponentProps<MatchParams>,
  State
> {
  constructor(
    props: GenericErrorPresenterProps &
      LocalizeProps &
      RouteComponentProps<MatchParams>,
  ) {
    super(props)
  }

  render() {
    return (
      <div className="error-page-wrapper">
        <FullLogo className="tw-mt-8 tw-h-8" />
        {this.props.error && (
          <div>
            <h1>{this.props.error.statusCode}</h1>
            <p>
              {' '}
              {
                this.props.translate(this.props.error.description) as string
              }{' '}
            </p>
            <Button
              variant="primary"
              size="sm"
              style={{ width: 230 }}
              onClick={() => {
                let returnUrl = corePath
                if (
                  !isAdmin() &&
                  !isPaymentAdmin() &&
                  this.props.companyId != null
                ) {
                  returnUrl = homeRoutesMap.dashboard.replace(
                    ':companyId',
                    this.props.companyId,
                  )
                }
                this.props.history.push(returnUrl)
              }}
            >
              {this.props.t('globalSettings.back_to_dashboard')}
            </Button>
          </div>
        )}
        {!this.props.error && (
          <div>
            <p>{this.props.translate('errorCodes.login-failed') as string} </p>
            <Button
              variant="primary"
              size="sm"
              style={{ width: 230 }}
              onClick={() => {
                this.props.history.push(corePath)
              }}
            >
              {this.props.t('globalSettings.back_to_dashboard')}
            </Button>
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(withLocalizeProps(GenericErrorPresenter) as any)
